import { centsToFormattedDollars } from '@fruitful/fruitils';
import { MoneyMapCategory } from '@fruitful/types';
import {
    BodyMediumEmphasized,
    BodyMediumRegular,
    LabelEmphasized,
    LabelRegular,
    redactPrivate,
    View,
    XStack,
} from 'smoothie';

import {
    MoneyMapCategoryToColorMap,
    MoneyMapCategoryToLabelMap,
} from '../constants';

interface MoneyMapCategoryHeaderProps {
    category: MoneyMapCategory;
    numAccounts: number;
    totalAmountCents: number | null;
}

export const MoneyMapCategoryHeader = ({
    category,
    numAccounts,
    totalAmountCents,
}: MoneyMapCategoryHeaderProps) => {
    const showMonthlyTotal = category !== MoneyMapCategory.OTHER_ACCOUNTS;

    return (
        <XStack
            backgroundColor={MoneyMapCategoryToColorMap[category]}
            alignItems="center"
            justifyContent={showMonthlyTotal ? 'space-between' : 'flex-start'}
            paddingVertical={6}
            paddingHorizontal={8}
            borderRadius={8}
            {...redactPrivate()}
        >
            <XStack gap={8} alignItems="center">
                <BodyMediumRegular>
                    {MoneyMapCategoryToLabelMap[category]}
                </BodyMediumRegular>
                <View
                    paddingVertical={4}
                    paddingHorizontal={8}
                    borderRadius={12}
                    backgroundColor="$white"
                >
                    <LabelRegular color="$gray900">{`${numAccounts} account${numAccounts !== 1 ? 's' : ''}`}</LabelRegular>
                </View>
            </XStack>
            {showMonthlyTotal && (
                <XStack alignItems="center">
                    <BodyMediumEmphasized>
                        {totalAmountCents != null
                            ? centsToFormattedDollars(totalAmountCents, false)
                            : '--'}
                    </BodyMediumEmphasized>
                    <LabelEmphasized>/mo</LabelEmphasized>
                </XStack>
            )}
        </XStack>
    );
};
